module.exports = __webpack_public_path__ + "img/shixi01.2aef9ba8.png";